<template>
  <div class="dashboard-mobile-nav">
    <button
      ref="menuToggle"
      type="button"
      class="mobile-menu-toggle"
      :class="{ 'is-open': sidebarOpen }"
      :aria-expanded="sidebarOpen ? 'true' : 'false'"
      aria-controls="dashboard-mobile-sidebar"
      aria-label="باز و بسته کردن منو"
      @click="toggleSidebar"
    >
      <span class="toggle-bars" aria-hidden="true">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </button>

    <b-sidebar
      id="dashboard-mobile-sidebar"
      :visible="sidebarOpen"
      class="dash-mobile-sidebar"
      bg-variant="dark"
      text-variant="light"
      right
      shadow
      backdrop
      no-header
      width="300px"
      @change="onSidebarChange"
      @hidden="closeSidebar"
      @hide="closeSidebar"
    >
      <div class="dash-mobile-head">
        <strong>منوی داشبورد</strong>
        <button
          type="button"
          class="dash-mobile-close"
          aria-label="بستن منو"
          @click="closeSidebar"
        >
          <b-icon icon="x-lg"></b-icon>
        </button>
      </div>

      <div class="dash-mobile-body">
        <menu-user-widget class="mb-3"/>
        <item
          v-for="(item,index) in items"
          :key="index"
          :icon="item.icon"
          :item-class="`${item.name}-${$store.getters['User/isAdmin'] ? 'admin' : 'user'}`"
          :id="item.id"
          :name="item.name"
          :access="item.access"
          :module="item.module"
          :action="item.action"
          :route="item.route"
          :badge="item.badge"
          :children="item.children"
        />
        <m-a class="dash-version" target="_blank" href="https://mixitweb.com/release-note">
          <span>ورژن:</span>
          {{ appVersion }}
        </m-a>
        <div class="dash-mobile-wave" aria-hidden="true"></div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import item from "./item";
import MenuUserWidget from "@/plugin/components/dashboard/DashboardMenu/MenuUserWidget.vue";
import pkg from '../../../../../package.json'

export default {
  name: "mobile",
  components: {MenuUserWidget, item},
  props: ['items'],
  data() {
    return {
      sidebarOpen: false,
      appVersion: pkg.devDependencies["@moeinmdn/mixitweb-front-modules"]
    }
  },
  watch: {
    $route() {
      this.closeSidebar()
    },
  },
  methods: {
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen
    },
    closeSidebar() {
      this.sidebarOpen = false
    },
    onSidebarChange(visible) {
      this.sidebarOpen = Boolean(visible)
    },
    onDocumentClick(event) {
      if (!this.sidebarOpen) {
        return
      }
      const toggle = this.$refs.menuToggle
      if (toggle && toggle.contains(event.target)) {
        return
      }
      const sidebar = document.getElementById('dashboard-mobile-sidebar')
      if (sidebar && sidebar.contains(event.target)) {
        return
      }
      this.closeSidebar()
    },
    onResize() {
      if (window.innerWidth > 1280) {
        this.closeSidebar()
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    document.addEventListener('click', this.onDocumentClick, true)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    document.removeEventListener('click', this.onDocumentClick, true)
  },
}
</script>

<style scoped>
.dashboard-mobile-nav {
  display: none;
  position: relative;
  z-index: 1080;
}

@media (max-width: 1280px) {
  .dashboard-mobile-nav {
    display: block;
  }
}

.mobile-menu-toggle {
  position: fixed;
  top: max(14px, env(safe-area-inset-top));
  right: max(14px, env(safe-area-inset-right));
  z-index: 1100;
  width: 52px;
  height: 52px;
  border: 0;
  border-radius: 50%;
  background: #1e1e1e;
  box-shadow: 0 10px 24px rgba(30, 30, 30, 0.28);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.mobile-menu-toggle.is-open {
  background: #eb3d60;
}

.toggle-bars {
  width: 18px;
  height: 14px;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
}

.toggle-bars span {
  display: block;
  height: 2px;
  border-radius: 999px;
  background: #fff;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.mobile-menu-toggle.is-open .toggle-bars span:nth-child(1) {
  transform: translateY(6px) rotate(45deg);
}

.mobile-menu-toggle.is-open .toggle-bars span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-toggle.is-open .toggle-bars span:nth-child(3) {
  transform: translateY(-6px) rotate(-45deg);
}

.dash-mobile-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px 10px;
  color: #fff;
}

.dash-mobile-close {
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.dash-mobile-body {
  padding: 0 12px 0;
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
}

.dash-version {
  display: block;
  margin-top: 10px;
  padding: 8px 12px;
  color: rgba(255, 255, 255, 0.55) !important;
  text-decoration: none !important;
  font-size: 12px;
}

.dash-mobile-wave {
  margin: auto -12px 0;
  height: 120px;
  pointer-events: none;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 120' preserveAspectRatio='none'%3E%3Cpath fill='%23eb3d60' fill-opacity='0.28' d='M0 48C40 12 80 84 128 44C176 4 216 88 264 48C288 28 308 56 320 40L320 120H0Z'/%3E%3Cpath fill='%23ff6b8a' fill-opacity='0.18' d='M0 72C52 40 92 100 148 68C204 36 244 104 296 72C308 64 316 80 320 76L320 120H0Z'/%3E%3C/svg%3E") no-repeat bottom / 100% 100%;
}

.dashboard-mobile-nav >>> .b-sidebar {
  background: #1e1e1e !important;
  color: #fff;
  width: min(320px, 86vw) !important;
  max-width: 320px;
}

.dashboard-mobile-nav >>> .b-sidebar-body {
  background: #1e1e1e;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.dashboard-mobile-nav >>> .b-sidebar-backdrop {
  background: rgba(30, 30, 30, 0.45);
}

@media print {
  .dashboard-mobile-nav {
    display: none !important;
  }
}
</style>
